import React from "react";
import { Button, Tag, Typography } from "antd";
import { Locale } from "../../../utils";
import "./coupons.scss";

const i18n = Locale.getInstance();
const { Text } = Typography;

export const PREVIEW_MAX_TAGS = 8;

function getItemLabel(selection, id) {
  const item = selection.byId[id];
  return item ? i18n.getPropNameByLocale(item, "name") : `#${id}`;
}

function ScopeTagList({ selection, ids, disabled, onRemove }) {
  return ids.map((id) => (
    <Tag
      key={id}
      closable={!disabled}
      onClose={(e) => {
        e.preventDefault();
        onRemove(id);
      }}
    >
      {getItemLabel(selection, id)}
    </Tag>
  ));
}

export function ScopeSelectionPreview({
  selection,
  disabled,
  onRemove,
  onClear,
  onShowAll,
}) {
  if (!selection.items.length) {
    return null;
  }

  const previewIds = selection.items.slice(0, PREVIEW_MAX_TAGS);
  const hiddenCount = selection.items.length - previewIds.length;

  return (
    <div className="scope-selection-preview">
      <div className="scope-selection-preview__header">
        <Text type="secondary">
          {i18n.t("sales.coupons.selectedCount", {
            count: selection.items.length,
          })}
        </Text>
        {!disabled && (
          <Button type="link" danger size="small" onClick={onClear}>
            {i18n.t("sales.gift.deleteAll")}
          </Button>
        )}
      </div>
      <div className="scope-selection-preview__tags">
        <ScopeTagList
          selection={selection}
          ids={previewIds}
          disabled={disabled}
          onRemove={onRemove}
        />
      </div>
      {hiddenCount > 0 && (
        <Button type="link" size="small" className="scope-selection-preview__more" onClick={onShowAll}>
          {i18n.t("sales.coupons.showAllSelected", {
            count: selection.items.length,
          })}
        </Button>
      )}
    </div>
  );
}

export function ScopeSelectionFooter({
  selection,
  disabled,
  onRemove,
  onClear,
}) {
  if (!selection.items.length) {
    return null;
  }

  return (
    <div className="scope-selection-footer">
      <div className="scope-selection-footer__header">
        <Text strong>
          {i18n.t("sales.coupons.selectedCount", {
            count: selection.items.length,
          })}
        </Text>
        {!disabled && (
          <Button type="link" danger size="small" onClick={onClear}>
            {i18n.t("sales.gift.deleteAll")}
          </Button>
        )}
      </div>
      <div className="scope-selection-footer__tags">
        <ScopeTagList
          selection={selection}
          ids={selection.items}
          disabled={disabled}
          onRemove={onRemove}
        />
      </div>
    </div>
  );
}
